<template>
  <div class="rounded bg-white">
    <div v-if="!(isTheSeller && isSuggestedCart)">
      <transition name="slide">
        <div v-if="showingDetails" class="row p-3">
          <div class="col-12 col-md-5 offset-md-1">
            <div>
              <strong>{{ sellerCompanyName }} - {{ sellerOperation.name }}</strong>
              <div v-if="sellerOperation && sellerOperation.state && sellerOperation.state.display_med_rec_designations" class="d-inline">
                <div v-if="sellerOperation.industry == 'Medical'" class="badge-med-rec badge-medical">Med</div>
                <div v-else-if="sellerOperation.industry == 'Recreational'" class="badge-med-rec badge-recreational">Rec</div>
              </div>
              <br />
              <span v-if="sellerOperation.line_one">{{ sellerOperation.line_one }}</span
              ><br v-if="sellerOperation.line_one" />
              <span v-if="sellerOperation.line_two">{{ sellerOperation.line_two }}</span
              ><br v-if="sellerOperation.line_two" />
              {{
                `${sellerOperation.city ? sellerOperation.city : ""}${sellerOperation.city ? "," : ""} ${
                  sellerOperation.state ? sellerOperation.state.text : ""
                } ${sellerOperation.zip ? sellerOperation.zip : ""} ${sellerOperation.country ? sellerOperation.country.value : ""}`
              }}<br />
              <span v-if="sellerOperation.turnaround_time"
                ><b> Typical Turnaround Time: {{ sellerOperation.turnaround_time }}</b></span
              >
            </div>
          </div>
          <div class="col-12 col-md-6 mt-2 mt-md-0">
            <hr class="d-md-none" />
            <p v-if="orderDetails.ship_name" class="mb-0">
              <b>{{ orderDetails.ship_name }}</b>
            </p>
            <p v-if="group.orderDetails.ship_line_one" class="mb-0">
              {{ orderDetails.ship_line_one }}
            </p>
            <p v-if="orderDetails.ship_line_two" class="mb-0">
              {{ orderDetails.ship_line_two }}
            </p>
            {{
              `${orderDetails.ship_city ? orderDetails.ship_city : ""}${orderDetails.ship_city ? "," : ""} ${
                orderDetails.ship_state ? orderDetails.ship_state : ""
              } ${orderDetails.ship_zip ? orderDetails.ship_zip : ""} ${orderDetails.ship_country ? orderDetails.ship_country : ""}`
            }}<br />
            <p v-if="usCannabisUser && orderDetails.buyer_state_license" class="mb-0">
              {{ orderDetails.buyer_state_license }}
            </p>
          </div>
        </div>
      </transition>
    </div>
    <div class="table-responsive">
      <table class="table table-valign-middle">
        <thead>
          <tr>
            <th />
            <th class="text-center">Name</th>
            <th class="text-center">Price</th>
            <th class="text-center">Quantity</th>
            <th class="text-right">
              <span class="mr-4">{{ "Line" }}</span>
            </th>
            <th />
          </tr>
        </thead>
        <tbody>
          <CartItem
            v-for="item in group.items"
            :key="item.id"
            :item="item"
            :cart-group="group"
            @remove-from-cart="(val) => $emit('removeFromCart', val)"
            @handle-update-quantity="(val) => $emit('handleUpdateQuantity', val)"
            @adjust-to-max-quantity-in-cart="(val) => $emit('adjustToMaxQuantityInCart', val)"
          />
          <tr>
            <td />
            <td />
            <td />
            <td />
            <td class="text-right">
              <div v-if="buyer && buyer.credit_total > 0 && groupTotal > 0">
                <div class="nowrap">
                  <b>
                    Subtotal:
                    {{ currency(groupTotal, "$") }}
                  </b>
                </div>
                <div class="nowrap">
                  <b>Credit Applied: - {{ currency(amountOfCreditToApply, "$") }} </b>
                </div>
                <div class="nowrap">
                  <b
                    >Total:
                    {{ currency(groupTotal - amountOfCreditToApply, "$") }}
                  </b>
                </div>
              </div>
              <div v-else>
                <b>
                  Total:
                  {{ currency(groupTotal, "$") }}
                </b>
              </div>
            </td>
            <td />
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row m-2 rounded">
      <!-- <div class="col-12 col-md-6">
        <BushelSelect
          v-if="shippingMethods.length >= 2"
          :searchable="false"
          :allow-empty="false"
          no-deselect
          preselect-first
          :options="shippingMethods"
          :label-active="'Shipping Method'"
          thin
          :value="shipping_method"
          @select="(val) => updateFieldInGroup('shipping_method', val)"
        />
        <BushelTextInput
          v-else
          :value="shipping_method"
          disabled
          :label-active="'Shipping Method'"
          type="text"
          @input="(val) => updateFieldInGroup('shipping_method', val)"
        />
      </div> -->
      <div class="col-12">
        <BushelTextArea
          :value="note"
          :name="'Notes'"
          label-active="Order Notes / Requests for Seller"
          :rows="2"
          type="text"
          @input="(val) => updateFieldInGroup('note', val)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import CartItem from "./CartItem.vue";
import { currency } from "@/services/filters";

export default {
  components: { CartItem },
  props: {
    buyer: { type: Object, required: true },
    group: { type: Object, required: true },
    sellerCompanyName: { type: String, required: true },
    submitted: { type: Boolean, required: true },
    usCannabisUser: { type: Boolean, required: true },
    sellerOperation: { type: Object, required: true },
    orderDetails: { type: Object, required: true },
    isTheSeller: { type: Boolean, required: true },
    isSuggestedCart: { type: Boolean, default: false },
    showingDetails: { type: Boolean, required: true },
  },
  emits: ["removeFromCart", "updateFieldInGroup", "handleUpdateQuantity", "adjustToMaxQuantityInCart"],
  data() {
    return {
      // shippingMethods: [],
      note: this.group.orderDetails.note,
      // shipping_method: this.group.orderDetails.shipping_method,
    };
  },
  computed: {
    amountOfCreditToApply() {
      if (this.buyer && this.buyer.credit_total && this.buyer.credit_total > 0 && this.groupTotal > 0) {
        return this.buyer.credit_total > this.groupTotal ? this.groupTotal : this.buyer.credit_total;
      }
      return 0;
    },
    groupTotal() {
      return this.group.items.reduce((accumulator, item) => accumulator + item.finalPrice, 0);
    },
  },
  watch: {
    group: {
      handler(val) {
        this.note = val.orderDetails.note;
        this.shipping_method = val.orderDetails.shipping_method;
      },
      deep: true,
    },
  },
  created() {},
  mounted() {
    // this.setShippingMethods();
  },
  methods: {
    // setShippingMethods() {
    //   const methods = [];
    //   if (this.sellerOperation) {
    //     methods.push('TBD');
    //     if (this.sellerOperation.shipping_pickup) {
    //       methods.push('Pickup');
    //     }
    //     if (this.sellerOperation.shipping_third_party) {
    //       methods.push('Third Party Logistics');
    //     }
    //     if (this.sellerOperation.shipping_free && this.sellerOperation.shipping_free_value < this.groupTotal) {
    //       methods.push('Request Free Shipping');
    //     }
    //   }
    //   this.shippingMethods = methods;
    // },
    currency,
    updateFieldInGroup(field, val) {
      const data = {
        opId: this.sellerOperation.id,
        field,
        value: val,
        identifier: this.group.identifier,
        batch_id: this.type == "White Label" ? this.group.items[0].batch_id : null,
      };
      this.$emit("updateFieldInGroup", data);
    },
  },
};
</script>

<style scoped>
:deep(.cart-group-header) {
  background-color: var(--bg-color) !important;
  border-bottom: 1px solid grey;
}
</style>
